import { useGetCommercePaymentsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetCommercePaymentsQuery as usePreviewGetCommercePaymentsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { useAppSelector } from '../redux';
import { selectIsPreview, selectPreviewJwt } from '../features/PreviewSlice/PreviewSelectors';
export function useCommercePaymentsData(variables) {
  var _useAppSelector;
  const isPreview = useAppSelector(selectIsPreview);
  const previewJwt = (_useAppSelector = useAppSelector(selectPreviewJwt)) !== null && _useAppSelector !== void 0 ? _useAppSelector : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetCommercePaymentsQuery({
    variables: Object.assign({
      previewJwt
    }, variables),
    skip: !isPreview
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useGetCommercePaymentsQuery({
    variables,
    skip: isPreview
  });
  if (isPreview) {
    return {
      loading: previewLoading,
      error: previewError,
      data: previewData
    };
  }
  return {
    loading,
    error,
    data: data !== null && data !== void 0 ? data : previousData === null || previousData === void 0 ? void 0 : previousData.result
  };
}